import timg1 from '../images/team/hose.jpg'
import timg2 from '../images/team/hydrolics-hose.jpg'
import timg3 from '../images/team/adaptor.jpg'
import timg4 from '../images/team/tubefittings.jpg'
import timg5 from '../images/team/quickrelease.jpg'
import timg6 from '../images/team/saeflange.jpg'


const Products = [
    {
        Id: '1',
        tImg:timg1,
        name:'HOSES',
        slug:'Hoses',       
        title:'Viewall Products',
    },
    {
        Id: '2',
        tImg:timg2,        
        name:'HYDRAULIC HOSE FITTINGS',
        slug:'hydrolicshose',          
        title:'Viewall Products',
    },
    {
        Id: '3',
        tImg:timg3,
        name:'ADAPTORS',
        slug:'adaptors', 
        title:'Viewall Products',
    },
    {
        Id: '4',
        tImg:timg4,
        name:'TUBE FITTINGS, TUBES & TUBE CLAMPS',
        slug:'tubefittings', 
        title:'Viewall Products',
    },
    {
        Id: '5',
        tImg:timg5,
        name:'QUICK RELEASE COUPLINGS',
        slug:'quickrelease', 
        title:'Viewall Products',
    },
    {
        Id: '6',
        tImg:timg6,
        name:'SAE FLANGE BLOCKS',
        slug:'seaflange', 
        title:'Viewall Products',
    },
]

export default Products;